import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../config.js";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  credentials: "same-origin",
  prepareHeaders: async (headers) => {
    headers.set("accept", "application/json");
    headers.append("Content-Type", "application/json");
    return headers;
  },
});

export const JobPortalApi = createApi({
  reducerPath: "jobportalApi",
  baseQuery: baseQuery,
  tagTypes: ['jobs'],
  endpoints: () => ({}),
});
